import React, { useEffect, useState } from "react";
import Style from "./ConfirmCode.module.css";
import Button from "../../Component/Button/Button";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import {
  ConfirmLoginPhoneNumber,
  LoginPhoneNumber,
} from "../../Api/BarestServices";
import { errorToast, succToast } from "../../Toast/Toast";
import LoadingComponet from "../../Component/LoadingComponet/LoadingComponet";
import Timer from "../../Component/Timer/Timer";

const ConfirmCode = (props) => {
  const history = useHistory("");
  const [remainTime, setReaminTime] = useState("");
  const [disable, setDisable] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(props.location.state);
  const [load, setLoad] = useState(false);
  const [resend, setResend] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getCode();
    if ("OTPCredential" in window) {
      readOTP();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCode = () => {
    setDisable(true);
    setLoad(true);
    let info = {
      phone: phoneNumber,
    };
    LoginPhoneNumber(info, (succ, res) => {
      setDisable(false);
      setLoad(false);
      if (res.status === 1) {
        succToast(res.message);
        setReaminTime(res.remaining_time);
        setResend(false);
        setPhoneNumber(res.phone);
        setTimeout(() => setResend(true), parseInt(`${res.remaining_time}000`));
      } else if (
        res.message === "شماره وارد شده اشتباه است!" ||
        res.message === "حسابی با این شماره یافت نشد!"
      ) {
        errorToast(res.message);
        setTimeout(() => history.push("./login"), 1000);
      } else {
        errorToast(res.message);
        setReaminTime(res.remaining_time);
        // setTimeout(() => history.push("./login"), 1000);
        setPhoneNumber(res.phone);
        setTimeout(() => setResend(true), parseInt(`${res.remaining_time}000`));
      }
    });
  };

  const readOTP = () => {
    const abortController = new AbortController();

    navigator.credentials
      .get({
        otp: { transport: ["sms"] },
        signal: abortController.signal,
      })
      .then((otp) => {
        const code = otp.code;
        setValue("code", code); // Automatically set the code in the input field
        succToast("کد تایید به‌صورت خودکار وارد شد.");
      })
      .catch((error) => {
        console.error("Failed to read OTP:", error);
      });

    return () => abortController.abort();
  };

  const onSubmitHandler = (data) => {
    setDisable(true);
    if (data.code === "") errorToast("لطفا کد را وارد کنید! ");
    else {
      let info = {
        phone: phoneNumber,
        code: data.code,
      };
      ConfirmLoginPhoneNumber(info, (succ, res) => {
        if (res.status === 1) {
          succToast(res.message);
          localStorage.setItem("JwtTokens", res.token);
          setTimeout(() => history.push("./"));
        } else if (res.status === 3) {
          setTimeout(() => history.push("/selectAddress"));
          localStorage.setItem("JwtTokens", res.token);
        } else if (res.status === 2) {
          localStorage.setItem("JwtTokens", res.token);
          setTimeout(() => history.push("/furtherInformation"));
        } else if (res.status === 0) {
          errorToast(res.message);
          setDisable(false);
        }
      });
    }
  };

  let loading = null;
  if (load === true) {
    loading = <LoadingComponet />;
  } else {
    loading = (
      <form
        onSubmit={handleSubmit(onSubmitHandler)}
        className={Style.CodeHolder}
      >
        <h2>کد دریافتی را وارد کنید</h2>
        <div className={Style.inputHolder}>
          <input
            {...register("code")}
            className={Style.telInput}
            placeholder=" کد دریافتی را وارد کنید"
            maxLength="11"
          />
        </div>
        {resend ? (
          <p className={Style.Resend} onClick={getCode}>
            ارسال دوباره
          </p>
        ) : (
          <Timer Time={remainTime} />
        )}
        <Button Value={"تایید"} ClassBtn={"confrimBtn"} disabled={disable} />
      </form>
    );
  }
  return (
    <div className={Style.PageHolder}>
      <div className={Style.ImageHolder}>
        <div className={Style.ImageFixed}>
          <img src="/Assets/Images/UserLogin/barestLogo.svg" alt="برست" />
        </div>
      </div>
      {loading}
    </div>
  );
};

export default ConfirmCode;
